// Header.jsx
import React from "react";
import {
    AppBar,
    Toolbar,
    Box,
    IconButton,
    Tooltip,
    Avatar,
    Badge
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../utils/AuthContext";
import packageJson from '../../../../package.json';

export default function Header({ onOpenNav, sidebarWidth = 0 }) {
    const { logout } = useAuth();
    const [busy, setBusy] = React.useState(false);

    const handleLogout = async () => {
        if (busy) return;
        setBusy(true);
        try {
            await logout();
        } finally {
            setBusy(false);
        }
    };

    return (
        <AppBar
            position="fixed"
            color="inherit"
            sx={{
                ml: { md: `${sidebarWidth}px` },                 // shift right on desktop
                width: { md: `calc(100% - ${sidebarWidth}px)` }, // adjust width on desktop
                borderBottom: "1px solid rgba(2,14,41,.08)",
                backgroundColor: "#fff",
            }}
        >
            <Toolbar sx={{ minHeight: 72, display: "flex", gap: 2 }}>
                <IconButton
                    edge="start"
                    onClick={onOpenNav}
                    sx={{ display: { md: "none" }, mr: 1 }}
                >
                    <MenuIcon />
                </IconButton>

                {/* Logo im Header */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                        component="img"
                        src={`${process.env.PUBLIC_URL}/images/krystin_ai_transparent.png`}
                        alt="Logo"
                        sx={{ width: 120, height: "auto" }}
                    />
                </Box>

                <Box sx={{ flexGrow: 1 }} />

                <Box
                    sx={{
                        mr: 2,
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 2,
                        fontSize: 12,
                        fontWeight: 600,
                        bgcolor: "rgba(2,14,41,.06)",
                        color: "text.secondary",
                        letterSpacing: 0.5
                    }}
                >
                    krystin.ai v{packageJson.version}
                </Box>

                <Tooltip title="Benachrichtigungen">
                    <IconButton>
                        <Badge color="primary" variant="dot" overlap="circular">
                            <NotificationsIcon />
                        </Badge>
                    </IconButton>
                </Tooltip>

                <Tooltip title="Account">
                    <Avatar sx={{ bgcolor: "secondary.main", width: 36, height: 36 }}>
                        FH
                    </Avatar>
                </Tooltip>

                <Tooltip title="Abmelden">
                    <span>
                        <IconButton onClick={handleLogout} disabled={busy}>
                            <LogoutIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Toolbar>
        </AppBar>
    );
}
